// class SocialFloating extends HTMLElement {
//   constructor() {
//     super();

//     // Prevent popup on Shopify robot challenge page
//     if (window.location.pathname === '/challenge') {
//       return;
//     }

//     this.classes = {
//       activeClass: 'is-active',
//       closingClass: 'is-closing'
//     };

//     this.querySelectorAll('[data-social-toggle]').forEach((button) => {
//       button.addEventListener('click', this.onButtonClick.bind(this));
//     });
//   }

//   onButtonClick(event) {
//     event.preventDefault();
//     if (!theme.config.mqlSmall) return;

//     this.classList.contains(this.classes.activeClass) ? this.close() : this.open();
//   }

//   open() {
//     this.classList.add(this.classes.activeClass);

//     // close promo-popup
//     const popup = document.querySelector('promo-popup');
//     popup && popup.close();
//   }

//   close() {
//     this.classList.add(this.classes.closingClass);

//     setTimeout(() => {
//       this.classList.remove(this.classes.activeClass);
//       this.classList.remove(this.classes.closingClass);
//     }, 500);
//   }
// }
// customElements.define('social-floating', SocialFloating);

// class PromoPopup extends HTMLElement {
//   constructor() {
//     super();

//     // Prevent popup on Shopify robot challenge page
//     if (window.location.pathname === '/challenge') {
//       return;
//     }

//     this.cookieName = 'developer:promo-popup';

//     this.classes = {
//       bodyClass: 'promo-popup--open',
//       activeClass: 'is-active',
//       closingClass: 'is-closing',
//       showImage: 'show-image'
//     };

//     this.popup = this.querySelector('.promo-popup');

//     // Open modal if errors or success message exist
//        // Open modal only if the success message comes from the popup form  --------------------------------------
//       const popupForm = this.querySelector('form');
//       if (this.querySelector('.form__message') && popupForm.contains(document.activeElement)) {
//         this.open();
//       }

// // -------------------------------------------------------------------------------------------------------------
//     // if (this.querySelector('.form__message')) {
//     //   this.open();
//     // }

//     this.querySelectorAll('[data-popup-toggle]').forEach((button) => {
//       button.addEventListener('click', this.onButtonClick.bind(this));
//     });

//     if (!this.getCookie(this.cookieName) || this.dataset.testMode === 'true') {
//       this.init();
//     }
//   }

//   connectedCallback() {
//     if (Shopify.designMode) {
//       this.onShopifySectionLoad = this.onSectionLoad.bind(this);
//       this.onShopifySectionSelect = this.onSectionSelect.bind(this);
//       this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
//       document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
//       document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
//       document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
//     }
//   }
//   disconnectedCallback() {
//     if (Shopify.designMode) {
//       document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
//       document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
//       document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);

//       document.body.classList.remove(this.classes.bodyClass);
//     }
//   }
//   onSectionLoad(event) {
//     filterShopifyEvent(event, this, () => this.open.bind(this));
//   }
//   onSectionSelect(event) {
//     filterShopifyEvent(event, this, this.open.bind(this));
//   }
//   onSectionDeselect(event) {
//     filterShopifyEvent(event, this, this.close.bind(this));
//   }

//   init() {
//     if (Shopify && Shopify.designMode) {
//       return;
//     }

//     setTimeout(function() {
//       this.open();
//     }.bind(this), parseInt(this.dataset.delay) * 1000);
//   }

//   onButtonClick(event) {
//     event.preventDefault();
//     this.popup.classList.contains(this.classes.activeClass) ? this.close() : this.open();
//   }

//   open() {
//     document.body.classList.remove(this.classes.bodyClass);
//     this.popup.classList.add(this.classes.activeClass);
//     setTimeout(() => {
//       this.popup.classList.add(this.classes.showImage);
//     }, 600);

//     if (this.popup.dataset.position === 'center') {
//       setScrollbarWidth();
//       document.body.classList.add(this.classes.bodyClass);
//     }

//     // close social-floating
//     const social = document.querySelector('social-floating');
//     social && social.close();
//   }

//   close() {
//     this.popup.classList.add(this.classes.closingClass);

//     setTimeout(() => {
//       this.popup.classList.remove(this.classes.activeClass);
//       this.popup.classList.remove(this.classes.closingClass);
//       this.popup.classList.remove(this.classes.showImage);

//       if (this.popup.dataset.position === 'center') {
//         document.body.classList.remove(this.classes.bodyClass);
//       }
//     }, 500);

//     // Remove a cookie in case it was set in test mode
//     if (this.dataset.testMode === 'true') {
//       this.removeCookie(this.cookieName);
//       return;
//     }

//     this.setCookie(this.cookieName, this.dataset.expiry);
//   }

//   getCookie(name) {
//     const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
//     return match ? match[2] : null;
//   }

//   setCookie(name, expiry) {
//     document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
//   }

//   removeCookie(name) {
//     document.cookie = `${name}=; max-age=0`;
//   }
// }
// customElements.define('promo-popup', PromoPopup);

// csutom1
// class SocialFloating extends HTMLElement {
//   constructor() {
//     super();

//     // Prevent popup on Shopify robot challenge page
//     if (window.location.pathname === '/challenge') {
//       return;
//     }

//     this.classes = {
//       activeClass: 'is-active',
//       closingClass: 'is-closing'
//     };

//     this.querySelectorAll('[data-social-toggle]').forEach((button) => {
//       button.addEventListener('click', this.onButtonClick.bind(this));
//     });
//   }

//   onButtonClick(event) {
//     event.preventDefault();
//     if (!theme.config.mqlSmall) return;

//     this.classList.contains(this.classes.activeClass) ? this.close() : this.open();
//   }

//   open() {
//     this.classList.add(this.classes.activeClass);

//     // close promo-popup
//     const popup = document.querySelector('promo-popup');
//     popup && popup.close();
//   }

//   close() {
//     this.classList.add(this.classes.closingClass);

//     setTimeout(() => {
//       this.classList.remove(this.classes.activeClass);
//       this.classList.remove(this.classes.closingClass);
//     }, 500);
//   }
// }
// customElements.define('social-floating', SocialFloating);

// class PromoPopup extends HTMLElement {
//   constructor() {
//     super();

//     // Prevent popup on Shopify robot challenge page
//     if (window.location.pathname === '/challenge') {
//       return;
//     }

//     // FIX: cookie name is now unique per popup role (entry vs exit).
//     // Before, both entry and exit popups shared the exact same cookie
//     // name ('developer:promo-popup'), so closing the entry popup set a
//     // cookie that also blocked the exit popup from ever showing again
//     // (and vice versa). Now each role gets its own cookie.
//     const popupRole = this.dataset.popupRole || 'entry';
//     this.cookieName = 'developer:promo-popup:' + popupRole;

//     this.classes = {
//       bodyClass: 'promo-popup--open',
//       activeClass: 'is-active',
//       closingClass: 'is-closing',
//       showImage: 'show-image'
//     };

//     this.popup = this.querySelector('.promo-popup');

//     // Open modal if errors or success message exist
//     // Open modal only if the success message comes from the popup form  --------------------------------------
//     const popupForm = this.querySelector('form');
//     if (this.querySelector('.form__message') && popupForm && popupForm.contains(document.activeElement)) {
//       this.open();
//     }

//     // -------------------------------------------------------------------------------------------------------------
//     // if (this.querySelector('.form__message')) {
//     //   this.open();
//     // }

//     this.querySelectorAll('[data-popup-toggle]').forEach((button) => {
//       button.addEventListener('click', this.onButtonClick.bind(this));
//     });

//     if (popupRole === 'exit') {
//       // Exit popups do NOT auto-open on a timer. They open the moment the
//       // visitor clicks a link that would take them away from the current
//       // page (About Us -> Home, About Us -> any other page, etc).
//       this.initExitTrigger();
//     } else if (!this.getCookie(this.cookieName) || this.dataset.testMode === 'true') {
//       this.init();
//     }
//   }

//   connectedCallback() {
//     if (Shopify.designMode) {
//       this.onShopifySectionLoad = this.onSectionLoad.bind(this);
//       this.onShopifySectionSelect = this.onSectionSelect.bind(this);
//       this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
//       document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
//       document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
//       document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
//     }
//   }
//   disconnectedCallback() {
//     if (Shopify.designMode) {
//       document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
//       document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
//       document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);

//       document.body.classList.remove(this.classes.bodyClass);
//     }
//   }
//   onSectionLoad(event) {
//     filterShopifyEvent(event, this, () => this.open.bind(this));
//   }
//   onSectionSelect(event) {
//     filterShopifyEvent(event, this, this.open.bind(this));
//   }
//   onSectionDeselect(event) {
//     filterShopifyEvent(event, this, this.close.bind(this));
//   }

//   init() {
//     if (Shopify && Shopify.designMode) {
//       return;
//     }

//     setTimeout(function() {
//       this.open();
//     }.bind(this), parseInt(this.dataset.delay) * 1000);
//   }

//   // Exit-intent link trigger: the first time the visitor clicks any
//   // internal link that navigates away from the current page, we pause
//   // that navigation, show this popup, and continue to the originally
//   // clicked link once the popup is closed.
//   initExitTrigger() {
//     // Respect the "don't show again" cookie, same as the entry popup does,
//     // unless we're in test mode (so merchants can preview it repeatedly).
//     if (this.getCookie(this.cookieName) && this.dataset.testMode !== 'true') {
//       return;
//     }

//     if (Shopify && Shopify.designMode) {
//       // Don't intercept clicks while editing the theme.
//       return;
//     }

//     this.exitTriggered = false;
//     this.pendingHref = null;

//     this.onDocumentClickBound = this.onDocumentClickForExit.bind(this);
//     document.addEventListener('click', this.onDocumentClickBound, true);
//   }

//   onDocumentClickForExit(event) {
//     if (this.exitTriggered) return;

//     const link = event.target.closest('a');
//     if (!link) return;

//     const hrefAttr = link.getAttribute('href');
//     if (!hrefAttr || hrefAttr.charAt(0) === '#') return;
//     if (link.target === '_blank') return;

//     let linkUrl;
//     try {
//       linkUrl = new URL(link.href, window.location.href);
//     } catch (err) {
//       return;
//     }

//     // Only intercept internal navigations to a different page.
//     if (linkUrl.hostname !== window.location.hostname) return;
//     if (linkUrl.href === window.location.href) return;

//     event.preventDefault();
//     this.exitTriggered = true;
//     this.pendingHref = link.href;
//     this.open();
//   }

//   onButtonClick(event) {
//     event.preventDefault();
//     this.popup.classList.contains(this.classes.activeClass) ? this.close() : this.open();
//   }

//   open() {
//     document.body.classList.remove(this.classes.bodyClass);
//     this.popup.classList.add(this.classes.activeClass);
//     setTimeout(() => {
//       this.popup.classList.add(this.classes.showImage);
//     }, 600);

//     if (this.popup.dataset.position === 'center') {
//       setScrollbarWidth();
//       document.body.classList.add(this.classes.bodyClass);
//     }

//     // close social-floating
//     const social = document.querySelector('social-floating');
//     social && social.close();
//   }

//   close() {
//     this.popup.classList.add(this.classes.closingClass);

//     setTimeout(() => {
//       this.popup.classList.remove(this.classes.activeClass);
//       this.popup.classList.remove(this.classes.closingClass);
//       this.popup.classList.remove(this.classes.showImage);

//       if (this.popup.dataset.position === 'center') {
//         document.body.classList.remove(this.classes.bodyClass);
//       }

//       // If this was an exit popup opened via a link click, continue on
//       // to the link the visitor originally clicked once they close it.
//       if (this.pendingHref) {
//         const href = this.pendingHref;
//         this.pendingHref = null;
//         window.location.href = href;
//       }
//     }, 500);

//     // Remove a cookie in case it was set in test mode
//     if (this.dataset.testMode === 'true') {
//       this.removeCookie(this.cookieName);
//       return;
//     }

//     this.setCookie(this.cookieName, this.dataset.expiry);
//   }

//   getCookie(name) {
//     const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
//     return match ? match[2] : null;
//   }

//   setCookie(name, expiry) {
//     document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
//   }

//   removeCookie(name) {
//     document.cookie = `${name}=; max-age=0`;
//   }
// }
// customElements.define('promo-popup', PromoPopup);

class SocialFloating extends HTMLElement {
  constructor() {
    super();

    // Prevent popup on Shopify robot challenge page
    if (window.location.pathname === '/challenge') {
      return;
    }

    this.classes = {
      activeClass: 'is-active',
      closingClass: 'is-closing'
    };

    this.querySelectorAll('[data-social-toggle]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    if (!theme.config.mqlSmall) return;

    this.classList.contains(this.classes.activeClass) ? this.close() : this.open();
  }

  open() {
    this.classList.add(this.classes.activeClass);

    // close promo-popup
    const popup = document.querySelector('promo-popup');
    popup && popup.close();
  }

  close() {
    this.classList.add(this.classes.closingClass);

    setTimeout(() => {
      this.classList.remove(this.classes.activeClass);
      this.classList.remove(this.classes.closingClass);
    }, 500);
  }
}
customElements.define('social-floating', SocialFloating);

class PromoPopup extends HTMLElement {
  constructor() {
    super();

    // Prevent popup on Shopify robot challenge page
    if (window.location.pathname === '/challenge') {
      return;
    }

    // Cookie name is unique per popup role (entry vs exit), so closing
    // one doesn't block the other from ever showing again.
    const popupRole = this.dataset.popupRole || 'entry';
    this.popupRole = popupRole;
    this.cookieName = 'developer:promo-popup:' + popupRole;

    this.classes = {
      bodyClass: 'promo-popup--open',
      activeClass: 'is-active',
      closingClass: 'is-closing',
      showImage: 'show-image'
    };

    this.popup = this.querySelector('.promo-popup');

    // Open modal if errors or success message exist.
    // Open modal only if the success message comes from the popup form.
    const popupForm = this.querySelector('form');
    if (this.querySelector('.form__message') && popupForm && popupForm.contains(document.activeElement)) {
      this.open();
    }

    this.querySelectorAll('[data-popup-toggle]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });

    if (popupRole === 'exit') {
      // Exit popups are NOT auto-opened here on a timer. They are opened
      // from outside, by the exit-intent trigger script (popup-exit-intent.js),
      // which calls this element's .open() method when it detects real
      // exit-intent signals (mouse toward top, fast scroll-up, back
      // button, tab/app switch). This keeps close()/open()/cookie logic
      // shared with the entry popup, while the "when to show" logic
      // lives in its own dedicated script.
    } else if (!this.getCookie(this.cookieName) || this.dataset.testMode === 'true') {
      this.init();
    }
  }

  connectedCallback() {
    if (Shopify.designMode) {
      this.onShopifySectionLoad = this.onSectionLoad.bind(this);
      this.onShopifySectionSelect = this.onSectionSelect.bind(this);
      this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
      document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }
  disconnectedCallback() {
    if (Shopify.designMode) {
      document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);

      document.body.classList.remove(this.classes.bodyClass);
    }
  }
  onSectionLoad(event) {
    filterShopifyEvent(event, this, () => this.open.bind(this));
  }
  onSectionSelect(event) {
    filterShopifyEvent(event, this, this.open.bind(this));
  }
  onSectionDeselect(event) {
    filterShopifyEvent(event, this, this.close.bind(this));
  }

  init() {
    if (Shopify && Shopify.designMode) {
      return;
    }

    setTimeout(function() {
      this.open();
    }.bind(this), parseInt(this.dataset.delay) * 1000);
  }

  onButtonClick(event) {
    event.preventDefault();
    this.popup.classList.contains(this.classes.activeClass) ? this.close() : this.open();
  }

  open() {
    this.classList.remove('hidden');
    document.body.classList.remove(this.classes.bodyClass);
    this.popup.classList.add(this.classes.activeClass);
    setTimeout(() => {
      this.popup.classList.add(this.classes.showImage);
    }, 600);

    if (this.popup.dataset.position === 'center') {
      setScrollbarWidth();
      document.body.classList.add(this.classes.bodyClass);
    }

    // close social-floating
    const social = document.querySelector('social-floating');
    social && social.close();
  }

  close() {
    this.popup.classList.add(this.classes.closingClass);

    setTimeout(() => {
      this.popup.classList.remove(this.classes.activeClass);
      this.popup.classList.remove(this.classes.closingClass);
      this.popup.classList.remove(this.classes.showImage);

      if (this.popup.dataset.position === 'center') {
        document.body.classList.remove(this.classes.bodyClass);
      }
      if (this.popupRole === 'exit') {
        this.classList.add('hidden');
      }
    }, 500);

    // Remove a cookie in case it was set in test mode
    if (this.dataset.testMode === 'true') {
      this.removeCookie(this.cookieName);
      return;
    }

    this.setCookie(this.cookieName, this.dataset.expiry);
  }

  getCookie(name) {
    const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match[2] : null;
  }

  setCookie(name, expiry) {
    document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
  }

  removeCookie(name) {
    document.cookie = `${name}=; max-age=0`;
  }
}
customElements.define('promo-popup', PromoPopup);
